export default __webpack_public_path__ + "static/media/side_image.03d5773a.png";